import React from "react";

const IconPin = ({ width, height, style }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width || "0.54em"} 
      height={height || "0.54em"} 
      viewBox="0 0 16.283 16.283"
    >
      <path className="a" fill="#0f4c82" d="M8.142,0A8.141,8.141,0,1,1,0,8.142H0A8.118,8.118,0,0,1,8.1,0Z" transform="translate(0 0)"/>
      <path className="b" fill="#fff" d="M91.045,105.263l-5.782,5.782-3.238-3.215,1.318-1.3,1.92,1.9,4.464-4.464Z" transform="translate(-78.394 -99.365)"/>
    </svg>
  );
};
export default IconPin;
